import { CaseData, HttpResponse } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint } from 'app/area/case/endpoints';
import { primaryKey } from 'app/infrastructure/data/wireformat';

export const api = {
  /**
   * Saves the case the same way a status change does. Warnings do not block the save.
   */
  saveCase: async (data: CaseData, eTag: string) =>
    new RemoteData(endpoint.case)
      .resource<HttpResponse<CaseData>>()
      .withId(primaryKey(data))
      .withIfMatch(eTag)
      .filter({ includeFailedConstraints: true, allowWarnings: true })
      .save(data)
};
